
const routes = {
  home: "/",
  job: "/viec-lam",
  company: "/cong-ty",
  news: "/tin-tuc",
  login: "/dang-nhap",
  registerCandidate: "/dang-ky/ung-vien",
  registerEmployer: "/dang-ky/nha-tuyen-dung",
  forgotPassword: "/quen-mat-khau",
  IndustrialPack: "/khu-cong-nghiep",
  // DetailJob: "/viec-lam/:id",
  // DetailIndustry: "/khu-cong-nghiep/:id",
  detailCompany: "/cong-ty/",
  resume: "/tao-ho-so",
  cv: "/ho-so",
  detailCv: "/ho-so-online/",
  profile: "/thong-tin-ca-nhan",
  createApplyLists: "/tao-gian-tuyen-dung",
};

export default routes;


